{
    "ReporttypeDesktopwallboard": "Desktop Wallboard (Unlicensed)",
    "ReporttypeDashboard": "Dashboard",
    "ReporttypeActivecalllist": "Active Call List (Unlicensed)",
    "ReporttypeHistoriccalllist": "Historic Call List",
    "ReporttypeUnreturnedlostcalls": "Unreturned Lost Calls (Unlicensed)",
    "ReporttypeExtensionlist": "Extension List (Unlicensed)",
    "ReporttypeAcdagentlist": "ACD Agent List (Unlicensed)",
    "ReporttypeHuntgrouplist": "Hunt Group List (Unlicensed)",
    "ReporttypeTrunkinterfacelist": "Trunk Interface List",
    "ReporttypeCallsbytelno": "Calls By Tel No",
    "ReporttypeCallsbyddi": "Calls By DDI (Unlicensed)",
    "ReporttypeCallsbyhalfhourinterval": "Calls By &#x00BD; Hour Interval",
    "ReporttypeCallsbyhalfhourplusday": "Calls By &#x00BD; Hour + Day",
    "ReporttypeCallsbyday": "Calls By Day",
    "ReporttypeCallsbyweek": "Calls By Week",
    "ReporttypeCallsbymonth": "Calls By Month",
    "ReporttypeCallsbyaccountcode": "Calls By Account Code (Unlicensed)",
    "ReporttypeAcddndactivitylog": "ACD / DND Activity Log (Unlicensed)",
    "ReporttypeAcsnacodeusage": "ACS N/A Code Usage (Unlicensed)",
    "ReporttypeExternalcontent": "External Content (Via URL)",
    "ReporttypeUnlicensedformattingstring": "|1 (Unlicensed)",

    "GroupLive": "Live Events",
    "GroupEntity": "Entity",
    "GroupLogs": "Logs",
    "GroupInterval": "Interval",
    "GroupMisc": "Miscellaneous",

    "NAME": "ReportTypes"
}